var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { to } from "@lib/utils";
import { Ticket } from "utils/mongo/tickets.model";
import { get, post } from "./api";
export const getTickets = () => __awaiter(void 0, void 0, void 0, function* () {
    const _tickets = yield get("/tickets/all");
    if (!_tickets)
        return [];
    const tickets = _tickets.map((t) => new Ticket(t));
    //useTicketStore.setState({ events });
    return tickets.sort((a, b) => a.displayOrder - b.displayOrder);
    //return tickets;
});
export const markTicket = (ticket, quantity) => __awaiter(void 0, void 0, void 0, function* () {
    const { err, res: data } = yield to(post(`/tickets/mark/${ticket.id}`, {
        quantity,
        priceId: ticket.currentPriceId,
    }));
    if (err || !data)
        return false;
    return true;
});
